import request from '@/utils/request'
let domain = process.env.NODE_ENV == 'production' ? 'https://lib.yiihuu.com' : 'http://test.lib.yiihuu.com:81'

// get 请求模板
export function getSign(query) {
    return request({
        url: 'https://lib-api.yiihuu.com/api/get_sign',
        // url: '/api/get_sign',
        method: 'get',
        params: query
    })
}

export function saveUserDesign(data) {
    return request({
        url: `${domain}/sc/ajax/save_user_design.php`,
        method: 'post',
        data
    })
}